import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { useTenantContext } from "../../tenant/TenantContext";

// Rojo fluorescente pedido por dirección para la pastilla del carrito: tiene que verse a la vista
const PILL_BASE = {
    color: "#fff",
    fontSize: "0.85rem",
    lineHeight: 1.4
};

/**
 * Aviso para productos bajo pedido con bypass de stock (details.stockBypass):
 * se pueden pedir aunque no haya unidades y la fecha estimada de entrega se
 * consulta por teléfono. El teléfono sale de la config del tenant (cada marca
 * enseña el suyo).
 *
 * variant="info" (por defecto): caja azul de aviso (modal de compra rápida).
 * variant="pill": pastilla para la ficha (bajo el precio) y la línea del carrito.
 * pillColor: "red" (carrito) o "primary" (ficha: el azul del tenant; en rojo quedaba raro).
 * message: texto alternativo (el texto de stock del producto que viene de BC, ej. "Disponible
 * en 10 días bajo pedido."); si no llega, se usa el genérico con el teléfono del tenant.
 */
export const StockBypassNotice = ({ product, className = "", variant = "info", pillColor = "red", message = null }) => {
    const { tel, primaryColor } = useTenantContext();
    if (!product?.stockBypass) {
        return null;
    }
    const content = message ? (
        <span>{message}</span>
    ) : (
        <span>
            Producto bajo pedido: puedes pedirlo aunque no haya stock. Si quieres saber la fecha
            estimada de entrega, llámanos{tel ? <> al <a href={`tel:${tel}`} className={`fw-bold text-nowrap ${variant === "pill" ? "text-white" : ""}`}>{tel}</a></> : null}.
        </span>
    );
    if (variant === "pill") {
        const pillStyle = {
            ...PILL_BASE,
            backgroundColor: pillColor === "primary" ? (primaryColor || "#0dcaf0") : "#ff1744"
        };
        return (
            <span className={`badge rounded-pill text-wrap text-start fw-normal d-inline-flex align-items-center gap-2 py-2 px-3 ${className}`}
                  style={pillStyle}
                  role="status">
                {!message && <PhoneInTalkIcon fontSize="small" />}
                {content}
            </span>
        );
    }
    return (
        <div className={`alert alert-info d-flex align-items-center gap-2 py-2 ${className}`} role="status">
            {!message && <PhoneInTalkIcon fontSize="small" />}
            {content}
        </div>
    );
};
